import { getLanguages } from './utils';

const i18nService = {
  getLanguages
};

export { i18nService as i18n };
